<template>
  <div class="pagination">
    <el-pagination
      background
      hide-on-single-page
      layout="prev, pager, next"
      v-bind="$attrs"
      v-on="$listeners"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
};
</script>
<style lang="scss" scoped>
.pagination {
  text-align: center;
  padding: 50px 0;
}
</style>
